import { FC } from "react";
import { User } from "../../../domain/models/User";
import { UserFields } from "../../../domain/enums/UserFieldsEnum";
import AddRowsSVG from "../../../components/shared/svg/AddRowsSVG";

interface UserTableRowProps {
    user: User;
    updateHandler: (user: User) => void;
}

const UserTableRow: FC<UserTableRowProps> = (props) => {
    const updateResidentHandler = () => {
        props.updateHandler(props.user);
    };

    return (
        <tr className="bg-light-bg-200 dark:bg-dark-bg-800 border-b hover:bg-gray-200 dark:hover:bg-dark-bg-800 border-light-border-200 dark:border-dark-border-200">
            {Object.values(UserFields).map((value, index) => {
                return (
                    <td
                        key={`td-users-table-${index}`}
                        className={`px-2 py-1 truncate ${
                            index === 0 ? "hover:whitespace-normal hover:overflow-visible hover:text-clip" : ""
                        } text-center max-w-[95px] border-light-border-200 dark:border-dark-border-200 border`}
                    >
                        {value === UserFields.ROLE_NAME ? props.user.role?.name ?? "-" : props.user[value]}
                    </td>
                );
            })}
            {/* <td className="px-2 py-1 border-light-border-200 dark:border-dark-border-200 border text-center">
                <button
                    onClick={updateResidentHandler}
                    className="flex items-center justify-center rounded-[8px] bg-[#5CD685E5] hover:opacity-80 w-[28px] h-[28px] mx-auto"
                    title="Редагувати"
                >
                    <AddRowsSVG className="w-[16px] h-[16px] fill-light-bg-200 dark:fill-dark-bg-800" />
                </button>
            </td> */}
        </tr>
    );
};

export default UserTableRow;
